import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import Footer from "./Footer";

import styles from "../styles/Compare";

import customStyle from "../styles/UserDemo.module.css";

class UserDemo extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.symptoms}>
        <h2 className={classes.heading}>
          <span>User Guide </span>
        </h2>
        <div className={classes.content}>
          <div className={classes.mainContent}>
            <div className={classes.alert}>
              <p >
                This is an automated data visualization Software which  works 
                as repository for all funds and schemes released or transfered by government
                to its benificiaries and help MoRD, bank and participating
                stackholders to make strong desicion to analyze and visualize scheme status.
              </p>
            </div>
            <div className={classes.symptomsMain}>
              <h1>Overview</h1>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/projectsih-894a3.appspot.com/o/userguide.jpeg?alt=media&token=2e1ab88c-700f-4c4a-95e1-50b0cc9b5184"
                height={420}
                width={700}
              />

              <p>
                <strong>State:</strong>
                <br /> 1. By clicking on state dropdown , list of all indian
                state will appear.
                <br />
                2. Select the state for which you wants to analize the scheme
                details.
              </p>
            </div>
            <div className={classes.symptomsDiv}>
              <h5 className={classes.symptomsHeading}>Schemes:</h5>
              <ul className={classes.sympList}>
                <p>
                  1. By clicking on Scheme dropdown, lists of different
                  government schemes will appear. <br />
                  2. Select the schemes, about which you wants know the details.
                  <br />
                </p>
              </ul>
              <h5 className={classes.symptomsHeading}>Year:</h5>
              <ul className={classes.sympList}>
                <p>
                  1. By clicking on year dropdown, lists of different financial
                  year will appear. <br />
                  2. Select the financial year, about which you wants know the
                  details.
                  <br />
                </p>
              </ul>
            </div>

            <div className={classes.symptomsMain}>
              <h1>Deep Analysis</h1>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/projectsih-894a3.appspot.com/o/WhatsApp%20Image%202022-08-25%20at%204.20.04%20PM.jpeg?alt=media&token=76f1245f-d82f-49e5-9f39-b61e98fa569a"
                height={420}
                width={700}
              />

              <p>
                <h2><strong>Apply filter here:</strong></h2>
                1. Select the state, district and schemes from apply here section.
                <br />
                2. finally you will get details of particular scheme upto village level in form of heat map.
                <br />
                3. More darker red region shows the village of selected district having higher percentage of benificiaries.
                <h3><strong>Save as image will give you ability to save image in your local system in png format</strong></h3>
                <h3><strong>Downloads csv helps you to download the data in excel format </strong></h3>
                <h3><strong>Through Downloads boundries you can download the geoJSON file of map</strong></h3>
                
                4. Zoom '+' and '-' help us to Zoom in and Zoom out the map respectively.
                <br/>
                5. Search bar help us to locate particular village.
                <br/>
                6. Full screen at right screen corner help us to view map on fullscren.
                
                

              </p>
            </div>
            <br/>

            <div className={classes.symptomsMain}>
              
              <h1>Compare</h1>
              <img src="https://firebasestorage.googleapis.com/v0/b/projectsih-894a3.appspot.com/o/compare.jpeg?alt=media&token=0006327f-b146-4a5d-a6c0-74a78a4d82c2" height={420} width={700}/>

              <p>
                1. At top most section we will see the list of state names.<br/>
                2. Select the states for  which you wants to compare the schemes.<br/>
                3. Line chart will appear which shows benificiaries strength year wise.
              </p>
            </div>

            <div className={classes.symptomsMain}>
              
              <h1>Our Team</h1>
              <img src="https://firebasestorage.googleapis.com/v0/b/projectsih-894a3.appspot.com/o/teampage.jpeg?alt=media&token=a98fc21b-2e86-4c35-89cd-7b2edbf61eb0" height={420} width={700}/>

              <p>
              <strong>This section contains the most important squad, The Webnior Family.</strong><br/>
              1. <b>Anurag Singh</b> (Team Leader)    DevOps, Technical Documentation.<br/>
              2. <b>Ayush Saxena</b>                  UI/UX Design<br/>
              3. <b>Mukesh Kumar Bagaria</b>          FrontEnd Design<br/>
              4. <b>Mithu Kumar Gupta</b>             FrontEnd Design<br/>
              5  <b>Swajeet Swarnkar</b>              BackEnd Design<br/>
              6. <b>Pushpanjali</b>                   Data Collection, Research<br/>
              </p>
            </div>

            <small className={classes.info}>
              content use are for reperesenation purpose only.
            </small>
          </div>
          <div className={classes.sidebar}>
            <div className={classes.video}>
              <iframe
                title="Project Demo"
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/7rgSUuF6FSY"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div>
              <h3>Video Tutorial</h3>
              <ul className={classes.helpfulLinks}>
                <li>
                  <Link className={classes.link} to="/">
                    Tutorial
                    <span>&rarr;</span>
                  </Link>
                </li>
                <li>
                  <a
                    className={classes.link}
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    lorem ipsum dolar
                    <span>&rarr;</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={classes.footer}>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(UserDemo);
